// extracted by mini-css-extract-plugin
export default {"container":"FormAddingAction_container__l2gBV"};